import { render, staticRenderFns } from "./ContactBarContent.vue?vue&type=template&id=49d5f46b&scoped=true&"
import script from "./ContactBarContent.vue?vue&type=script&lang=js&"
export * from "./ContactBarContent.vue?vue&type=script&lang=js&"
import style0 from "./ContactBarContent.vue?vue&type=style&index=0&id=49d5f46b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5f46b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow,VSpacer})
